<div *ngIf="user.Role !== 'User' && user.Role !== 'Repartidor'">
    <app-header
      class="layout-header"
      [menuToggleEnabled]="true"
      (menuToggle)="menuOpened = !menuOpened;"
      [title]="title">
    </app-header>
</div>
<div *ngIf="user.Role == 'User' || user.Role == 'Repartidor'">
    <app-header
      class="layout-header"
      [menuToggleEnabled]="false"
      (menuToggle)="menuOpened = false;"
      [title]="title">
    </app-header>
</div>
  <dx-drawer
    class="layout-body"
    position="before"
    [closeOnOutsideClick]="shaderEnabled"
    [openedStateMode]="menuMode"
    [revealMode]="menuRevealMode"
    [minSize]="minMenuSize"
    [shading]="shaderEnabled"
    [(opened)]="menuOpened">
  
    <div *ngIf="user.Role !== 'User' && user.Role !== 'Repartidor'">

      <app-side-navigation-menu
        [compactMode]="!menuOpened"
        [selectedItem]="selectedRoute"
        class="dx-swatch-additional"
        *dxTemplate="let dataMenu of 'panel'"
        (selectedItemChanged)="navigationChanged($event)"
        (openMenu)="navigationClick()">
      </app-side-navigation-menu>
    </div>
 
    <dx-scroll-view class="with-footer" [useNative]="true">
      <div class="content">
        <ng-content></ng-content>
      </div>
  
      <div class="content-block">
        <ng-content select="app-footer"></ng-content>
      </div>
    </dx-scroll-view>
  </dx-drawer>
   

  
 